/* prettier-ignore */

import { Component, EventEmitter, inject, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/services/auth.service";
import { RestService } from "src/app/services/rest.service";
import { ToolsService } from "src/app/services/tools.service";
import { UserService } from "src/app/services/user.service";
import { PDFViewerComponent } from "../pdf-viewer/pdf-viewer.page";
import { NewCustomRouteService } from "src/app/pages/new-custom-route/new-custom-route.service";
import { DebugService } from "src/app/services/debug.service";
import { catchError, EMPTY } from "rxjs";


@Component({
  selector: "cicerone-generic-card",
  templateUrl: "./generic-card.component.html",
  styleUrls: ["./generic-card.component.scss"],
  encapsulation: ViewEncapsulation.None
  
})
export class GenericCardComponent {
  private debugService = inject(DebugService);
  
  @Input() seeMore?: boolean = false;
  @Input() item?: any;
  @Input() isCategoryList: boolean = false;
  @Input() isPdfCheckbox?: any;
  @Input() isSelected?: any;
  @Output() public pdfEmitter? = new EventEmitter();
  public modal: any;

  constructor(
    private router: Router,
    public translate: TranslateService,
    public rest: RestService,
    public tools: ToolsService,
    public authService: AuthService,
    public userService: UserService,
    public user: UserService,
    public modalCtrl: ModalController,
    private routeService: NewCustomRouteService
  ) {}

  goToDetails(item) {
    console.log(item);
    if (item.type === "pdf") 
      this.openModalPDF(item);

    if (item.type === "point")
      this.router.navigate([`/point/${item.nameSlug[this.translate.currentLang]}/${item.id}`]);

    if (item.type === "event")
      this.router.navigate([`/event/${item.nameSlug[this.translate.currentLang]}/${item.id}`]);
    
    if(item.type === "hiking")
      this.router.navigate([`/hiking/${item.nameSlug[this.translate.currentLang]}/${item.id}`]);
  }

  isNumber(value) {
    return !isNaN(value);
  }

  checkItemToRoute(item) {
    return item?.duration > 0 && item?.coordinates && item.coordinates !== "" && item?.type !== "pdf";
  }

  setFavourite(item) {
    if (!this.authService.userValue) {
      this.userService.login();
      return;
    }

    if (item.type == "point") {
      const foundPoint = this.user.favouritesPoints.find(
        (point) => point == item.id
      );
      if (foundPoint) {
        this.user.favouritesPoints = this.user.favouritesPoints.filter((point) => point != foundPoint);
        this.user.removeFavouritePoint(item.id).subscribe((res) => {
          this.debugService.debug(res, `[GenericCardComponent] Point ${item.id} removed from favourites`);
        });
      } else {
        this.user.addFavouritePoint(item.id)
        .pipe(
          catchError(error => {
            this.debugService.debug(error, `[GenericCardComponent] Error adding event ${item.id} to favourites`);
            this.userService.showErrorSwalFavourtives();
            return EMPTY; 
          })
        )
        .subscribe((res) => {
          this.debugService.debug(res, `[GenericCardComponent] Point ${item.id} added to favourites`);
          this.user.favouritesPoints.push(item.id);
          this.userService.showSuccessSwalFavourtives();
        });
      }
    }

    if (item.type == "event") {
      const founEvent = this.user.favouritesEvents.find(
        (event) => event == item.id
      );
      if (founEvent) {
        this.user.favouritesEvents = this.user.favouritesEvents.filter(
          (event) => event != founEvent
        );
        this.user.removeFavouriteEvent(item.id).subscribe((res) => {
          this.debugService.debug(res, `[GenericCardComponent] Event ${item.id} removed from favourites`);
        });
      } else {
        this.user.addFavouriteEvent(item.id)
        .pipe(
          catchError(error => {
            this.debugService.debug(error, `[GenericCardComponent] Error adding event ${item.id} to favourites`);
            this.userService.showErrorSwalFavourtives();
            return EMPTY; 
          })
        )
        .subscribe((res) => {
          this.debugService.debug(res, `[GenericCardComponent] Event ${item.id} added to favourites`);
          this.user.favouritesEvents.push(item.id);
          this.userService.showSuccessSwalFavourtives();
        });
      }
    }
    
    if (item.type == "hiking") {
      const foundHinking = this.user.favouritesHikings.find(
        (hiking) => hiking == item.id
      );
      if (foundHinking) {
        this.user.favouritesHikings = this.user.favouritesHikings.filter(
          (hiking) => hiking != foundHinking
        );
        
        this.user.removeFavouriteHiking(item.id).subscribe((res) => {
         this.debugService.debug(res, `[GenericCardComponent] Hiking ${item.id} removed from favourites`);
        });
      } else {
        this.user.addFavouriteHiking(item.id)
        .pipe(
          catchError(error => {
            this.debugService.debug(error, `[GenericCardComponent] Error adding event ${item.id} to favourites`);
            this.userService.showErrorSwalFavourtives();
            return EMPTY; 
          })
        )
        .subscribe((res) => {
          this.debugService.debug(res, `[GenericCardComponent] Hiking ${item.id} added to favourites`);
          this.user.favouritesHikings.push(item.id);
          this.userService.showSuccessSwalFavourtives();
        });
      }
    }
  }

  emitPdf(event, pdfId){
    event.stopPropagation();
    this.pdfEmitter.emit(pdfId);
  }

  isTechItemSelected(item){
    return this.routeService.techSelectedPoints()?.find(point => point === item.id) || this.routeService.techSelectedEvents()?.find(point => point === item.id)
  }

  setTechItem(event, item){
    event.stopPropagation();
    if (item.type === 'point')
      this.routeService.toggleTechPoints(item.id);

    if (item.type === 'event'){
      this.routeService.toggleTechEvents(item.id);
    }
  }

  async openModalPDF(pdf){
    this.modal = await this.modalCtrl.create({
      component: PDFViewerComponent,
      cssClass: ['pdfModal', 'ion-disable-focus-trap'],
      componentProps: { pdf: pdf.url[this.translate.currentLang], name: pdf.name[this.translate.currentLang], id: pdf.id }
    });
    await this.modal.present();
  }

  isFavourite(item){
    if (item?.type === 'point')
      return this.user.favouritesPoints.includes(item.id)

    if (item?.type === 'event')
      return this.user.favouritesEvents.includes(item.id)
    
    if (item?.type === 'hiking')
      return this.user.favouritesHikings.includes(item.id)

    return false;
  }

  showTimeIcon(item){
    return (!item.offers || item.offers?.length == 0) && item.duration && item.duration > 0
  }

  showOfferIcon(item){
    return item.offers?.length > 0;
  }

  showFavouriteIcon(item){
    return this.tools.isApp && (item.type === 'point' || item.type === 'event' || item.type === 'hiking') && !this.tools.isTechMode()
  }

  minuteToHours(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    let result = "";

    const hourString = this.translate.instant('hora');
    const minuteString = this.translate.instant('minuto');

    const hoursString = this.translate.instant('horas');
    const minutesString = this.translate.instant('minutos');

    if (hours > 0) 
      result += `${hours} ${hours !== 1 ? hoursString : hourString}`;

    if (mins > 0) {
      if (result) result += " ";
      result += `${mins} ${mins !== 1 ? minutesString : minuteString}`;
    }

    return result;
  }

}
